export const resetAlerts = () => dispatch => {
  setTimeout(() => {
    dispatch({ type: "RESET_ALERTS" });
  }, 4000);
};

export const resetCloseModal = () => dispatch => {
  dispatch({ type: "RESET_CLOSE_MODAL" });
};
